module.exports = __webpack_public_path__ + "static/media/c2_3.8365859e.png";